<template>
  <GmapMap
    ref="mapRef"
    @dblclick="mark"
    :center="center"
    :zoom="zoom"
    class="map-container"
    :options="{
      disableDoubleClickZoom: true
    }"
  >
    <GmapInfoWindow
      :options="infoOptions"
      :position="infoWindowPos"
      :opened="infoWinOpen"
      @closeclick="closeMap"
    ></GmapInfoWindow>
    <GmapMarker
      :key="i"
      v-for="(key, i) in locations"
      :icon="
        reporting
          ? key.building_type == 'Apartment'
            ? {
                url: require('../assets/marker/apartment-purple.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Hotel'
            ? {
                url: require('../assets/marker/hotel-purple.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Retail'
            ? {
                url: require('../assets/marker/retail-purple.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Office'
            ? {
                url: require('../assets/marker/office-purple.png'),
                scaledSize: sizeIcon
              }
            : {
                url: require('../assets/marker/other-purple.png'),
                scaledSize: sizeIcon
              }
          : installation.includes('complete', 'incomplete', 'needrequest')
          ? key.building_type == 'Apartment'
            ? {
                url: require('../assets/marker/apartment-purple.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Hotel'
            ? {
                url: require('../assets/marker/hotel-purple.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Retail'
            ? {
                url: require('../assets/marker/retail-purple.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Office'
            ? {
                url: require('../assets/marker/office-purple.png'),
                scaledSize: sizeIcon
              }
            : {
                url: require('../assets/marker/other-purple.png'),
                scaledSize: sizeIcon
              }
          : installation == 'incomplete' ||
            installation == 'needrequest' ||
            installation.includes('incomplete', 'needrequest')
          ? key.building_type == 'Apartment'
            ? {
                url: require('../assets/marker/apartment-yellow.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Hotel'
            ? {
                url: require('../assets/marker/hotel-yellow.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Retail'
            ? {
                url: require('../assets/marker/retail-yellow.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Office'
            ? {
                url: require('../assets/marker/office-yellow.png'),
                scaledSize: sizeIcon
              }
            : {
                url: require('../assets/marker/other-yellow.png'),
                scaledSize: sizeIcon
              }
          : (key.screen_installed == null || key.tower_id == null) &&
            (key.fmi == 'Yes' || key.dfi == 'Yes' || key.other == 'Yes') // Competitor
          ? key.building_type == 'Apartment'
            ? {
                url: require('../assets/marker/apartment-red.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Hotel'
            ? {
                url: require('../assets/marker/hotel-red.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Retail'
            ? {
                url: require('../assets/marker/retail-red.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Office'
            ? {
                url: require('../assets/marker/office-red.png'),
                scaledSize: sizeIcon
              }
            : {
                url: require('../assets/marker/other-red.png'),
                scaledSize: sizeIcon
              }
          : key.tower_id !== null &&
            key.screen_installed !== null &&
            key.fmi == 'No' &&
            key.dfi == 'No' &&
            key.other == 'No' // TMN
          ? key.building_type == 'Apartment'
            ? {
                url: require('../assets/marker/apartment-purple.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Hotel'
            ? {
                url: require('../assets/marker/hotel-purple.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Retail'
            ? {
                url: require('../assets/marker/retail-purple.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Office'
            ? {
                url: require('../assets/marker/office-purple.png'),
                scaledSize: sizeIcon
              }
            : {
                url: require('../assets/marker/other-purple.png'),
                scaledSize: sizeIcon
              }
          : key.tower_id !== null &&
            (key.fmi == 'Yes' || key.dfi == 'Yes' || key.other == 'Yes') // TMN + Competitor
          ? key.building_type == 'Apartment'
            ? {
                url: require('../assets/marker/apartment-blue.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Hotel'
            ? {
                url: require('../assets/marker/hotel-blue.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Retail'
            ? {
                url: require('../assets/marker/retail-blue.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Office'
            ? {
                url: require('../assets/marker/office-blue.png'),
                scaledSize: sizeIcon
              }
            : {
                url: require('../assets/marker/other-blue.png'),
                scaledSize: sizeIcon
              }
          : key.tower_id == null &&
            key.fmi == 'No' &&
            key.dfi == 'No' &&
            key.other == 'No' // Opportunity
          ? key.building_type == 'Apartment'
            ? {
                url: require('../assets/marker/apartment-gray.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Hotel'
            ? {
                url: require('../assets/marker/hotel-gray.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Retail'
            ? {
                url: require('../assets/marker/retail-gray.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Office'
            ? {
                url: require('../assets/marker/office-gray.png'),
                scaledSize: sizeIcon
              }
            : {
                url: require('../assets/marker/other-gray.png'),
                scaledSize: sizeIcon
              }
          : key.tower_id !== null &&
            key.screen_installed == null &&
            key.screen_installed == null &&
            key.fmi == 'No' &&
            key.dfi == 'No' &&
            key.other == 'No' // TMN ( Belum di install)
          ? key.building_type == 'Apartment'
            ? {
                url: require('../assets/marker/apartment-yellow.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Hotel'
            ? {
                url: require('../assets/marker/hotel-yellow.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Retail'
            ? {
                url: require('../assets/marker/retail-yellow.png'),
                scaledSize: sizeIcon
              }
            : key.building_type == 'Office'
            ? {
                url: require('../assets/marker/office-yellow.png'),
                scaledSize: sizeIcon
              }
            : {
                url: require('../assets/marker/other-yellow.png'),
                scaledSize: sizeIcon
              }
          : 'not valid'
      "
      :position="key.coordinates"
      :clickable="true"
      @click="toggleInfoWindow(key, i, '')"
    ></GmapMarker>
    <GmapCircle
      v-if="!showMultipleMark"
      :center="center"
      :radius="radius"
      :visible="true"
      :options="{
        fillColor: 'red',
        fillOpacity: 0.2,
        strokeWeight: 1,
        strokeOpacity: 1,
        strokeColor: 'red'
      }"
    ></GmapCircle>
    <GmapMarker
      :icon="generateMarker('#ffe34c')"
      v-if="!showMultipleMark"
      :position="center"
      :clickable="false"
      :draggable="false"
    ></GmapMarker>
    <!-- GMAP POTENTIAL CLIENTS -->
    <div v-for="(item, index) in multipleMarkData" :key="`${index}-multi`">
      <GmapMarker
        :position="item.center"
        :icon="item.icon"
        :draggable="false"
        @click="seeDetailPlaces(item.id)"
      ></GmapMarker>
      <GmapCircle
        :center="item.center"
        :radius="radius"
        :visible="true"
        :options="{
          fillColor: 'red',
          fillOpacity: 0.2,
          strokeWeight: 1,
          strokeOpacity: 1,
          strokeColor: 'red'
        }"
      ></GmapCircle>
    </div>
  </GmapMap>
</template>

<script>
import axios from "axios";
import uniq from "lodash/uniq";
import { EventBus } from "@/utils/eventBus";
import { getToken } from "../utils/auth";
import { generateMarker } from "../utils/markers";

export default {
  data() {
    return {
      sizeIcon: { width: 20, height: 30, f: "px", b: "px" },
      zoom: 12,
      locations: [],
      value: [],
      valueCenter: {
        address: "",
        lat: "",
        lng: ""
      },
      // Object Data includes
      // center: [] // latLng
      // id: 0 // places id
      showMultipleMark: false,
      multipleMarkData: [],
      center: {
        lat: -6.2,
        lng: 106.816666
      },
      place: null,
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        content: "",
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      region: [],
      district_subdistrict: [],
      lat: [],
      lng: [],
      buildingType: [],
      buildingGrade: [],
      installation: [],
      screenSize: [],
      screenPoint: [],
      progress: [],
      lcdPresence: [],
      year: [],
      radius: 0,
      reporting: false
    };
  },
  async created() {
    await this.$gmapApiPromiseLazy();
    // eslint-disable-next-line no-undef
    EventBus.$on("TYPE_EVENT", value => {
      this.filterData(value);
    });

    EventBus.$on("RESET_POINT", () => {
      this.multipleMarkData = [];
      this.showMultipleMark = false;
    });

    EventBus.$on("TYPE_RESET", value => {
      this.radius = 0;
      this.filterData(value);
    });

    EventBus.$on("SELECT_POTENTIAL_CLIENT", async value => {
      await this.fetchPotentialClientPlaces(value);
    });
  },
  mounted() {
    this.filterData({
      type: "lcd_presence",
      data: ["TMN"]
    });

    if (getToken("role") == 12) {
      this.reporting = true;
    }
  },
  methods: {
    generateMarker,
    async seeDetailPlaces(id) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("api_token")
      };
      const url = `${process.env.VUE_APP_API_URL}/api/admin/potentialclient-place/${id}`;
      const response = await axios.get(url, { headers });
      EventBus.$emit("FETCH_CLIENT_PLACES", response.data.data);
    },
    async fetchPotentialClientPlaces(id) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("api_token")
      };
      const url = `${process.env.VUE_APP_API_URL}/api/admin/potentialclient/${id}`;
      const response = await axios.get(url, { headers });
      const places = response.data.data.places;
      this.multipleMarkData = [];
      this.multipleMark(places, response.data.data.color);
      this.filterData({ data: places, type: "places" });
    },
    async multipleMark(values, color) {
      this.showMultipleMark = true;
      const icon = generateMarker(color);
      for (let i = 0; i < values.length; i++) {
        const place = values[i];
        this.multipleMarkData.push({
          center: {
            lng: place.latlang.coordinates[0],
            lat: place.latlang.coordinates[1]
          },
          icon,
          id: place.id
        });
      }
    },
    async mark(event) {
      this.showMultipleMark = false;
      let url =
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        event.latLng.lat() +
        ", " +
        event.latLng.lng() +
        "&sensor=true&key=" +
        process.env.VUE_APP_GMAPS;

      const response = await axios.get(url);
      let value = response.data.results[0].formatted_address;
      this.valueCenter = {
        address: value,
        lat: response.data.results[0].geometry.location.lat,
        lng: response.data.results[0].geometry.location.lng
      };
      EventBus.$emit("UPDATE_INPUT", value);
      this.center = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      };
    },
    toggleInfoWindow: function(locations, idx, type) {
      // let building_name, address, lat, lng, coordinates;
      let address;

      if (type == "center") {
        address = this.valueCenter.address;
        if (address == "") {
          this.infoWinOpen = false;
        } else {
          this.infoWinOpen = true;
        }
      } else {
        let building_id = locations.id;
        address = locations.address;

        EventBus.$emit("TYPE_DETAIL_BUILDING", { building_id, address });

        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen;
        } else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      }
    },
    closeMap() {
      this.infoWinOpen = false;
      EventBus.$emit("TYPE_CLOSE_MAP", this.infoWinOpen);
    },
    async filterData(data) {
      let url, queryParams;
      if (data == "" || data == "reset") {
        this.district = [];
        this.subdistrict = [];
        this.screenType = [];
        this.progress = [];
        this.lcdPresence = [];
        this.buildingGrade = [];
        this.buildingType = [];
        this.installation = [];
        this.year = [];
        this.radius = 0;

        url = `${process.env.VUE_APP_API_URL}/api/admin/mapping-building/cache?filter[lcd_presence]=TMN`;

        // Export data emit
        EventBus.$emit("TYPE_EXPORT", "");
      } else {
        if (data.data.lat !== undefined && data.data.lng !== undefined) {
          this.center = {
            lat: data.data.lat,
            lng: data.data.lng
          };
        }

        let dataScreenSize = [];
        let dataScreenPoint = [];

        // Set Marker
        this.lat = this.center.lat;
        this.lng = this.center.lng;

        if (data.type === "region") {
          this.lat = data.data.lat;
          this.lng = data.data.lng;
        } else if (data.type === "building_type") {
          this.buildingType = data.data;
        } else if (data.type === "building_grade") {
          this.buildingGrade = data.data;
        } else if (data.type === "installation") {
          this.installation = data.data;
        } else if (data.type === "screen_type") {
          for (var i = 0; i < data.data.length; i++) {
            let parse = JSON.parse(data.data[i]);

            dataScreenSize.push(parse.screensize_id);
            dataScreenPoint.push(parse.screenpoint_id);
          }

          this.screenSize = uniq(dataScreenSize).toString();
          this.screenPoint = uniq(dataScreenPoint).toString();
        } else if (data.type === "progress") {
          this.progress = data.data;
        } else if (data.type === "lcd_presence") {
          this.lcdPresence = data.data;
        } else if (data.type === "year") {
          this.year = data.data;
        } else if (data.type === "radius") {
          this.radius = data.data;
        } else if (data.type === "district_subdistrict") {
          this.district_subdistrict = data.data;
        } else if (data.type === "places") {
          this.place = data.data.map(p => p.id).join(",");
        }

        queryParams = `?filter[building_name]=&filter[region]=${
          this.district_subdistrict
        }&filter[building_type]=${this.buildingType}&filter[building_grade]=${
          this.buildingGrade
        }&filter[year]=${this.year}&filter[installation]=${
          this.installation
        }&filter[screen_type]=${this.screenSize}&filter[screen_point]=${
          this.screenPoint
        }&filter[lcd_presence]=${this.lcdPresence}&filter[progress]=${
          this.progress
        }&filter[lat]=${this.lat}&filter[lng]=${this.lng}&filter[radius]=${
          this.radius === 0 ? "" : this.radius
        }&filter[places_id]=${this.place}`;

        url = `${process.env.VUE_APP_API_URL}/api/admin/mapping-building/cache${queryParams}`;

        // Export data emit
        EventBus.$emit("TYPE_EXPORT", queryParams);
      }

      try {
        const token = getToken("api_token");
        const headers = {
          Authorization: token
        };
        const response = await axios.get(url, { headers });
        this.locations = response.data.data;
        EventBus.$emit("UPDATE_DATA", response.data ?? {});
        this.feedLoaded = true;
      } catch (err) {
        throw new Error(err);
      }
    }
  }
};
</script>

<style scoped>
.map-container {
  width: 100%;
  height: 100%;
}
</style>
